const initialState = 1;

const alertsPaginationReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_ALERTS_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                  return 1;
            default:
                  break;
      }
      return state;
};
export default alertsPaginationReducer;